import axios from 'axios';
import { config } from 'config/env';
import traceId from '../../../redux/traceId';

export type InboxNotification = {
  id: number;
  event_type: string;
  scope: 'user' | 'broadcast';
  external_event_id: string;
  payload_json: Record<string, unknown>;
  notification_title: string | null;
  notification_text: string | null;
  notification_link: string | null;
  tool_path: string | null;
  created_at: string;
  read: boolean;
};

export type InboxResponse = {
  notifications: InboxNotification[];
  unread_count: number;
  unread_count_by_path: Record<string, number>;
  total: number;
};

export async function getNotificationsInbox(
  authToken: string,
): Promise<InboxResponse> {
  const response = await axios.get<InboxResponse>(
    `${config.jusfyBackend.apiUrl}/notifications`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
        'x-trace-id': traceId,
      },
    },
  );

  return response.data;
}

export async function markNotificationAsRead(
  authToken: string,
  notificationId: number,
): Promise<void> {
  await axios.post(
    `${config.jusfyBackend.apiUrl}/notifications/${notificationId}/read`,
    undefined,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
        'Content-Type': 'application/json',
        'x-trace-id': traceId,
      },
    },
  );
}
